import { serverUrl, getheader } from "./CommonFunctions";
export function getComplaintsMainGroupList() {
    return dispatch => {
        dispatch({
            type: "GET_COMPLAINT_MAINGROUP",
            data: "PENDING"
        });
        fetch(serverUrl + "api/ComplaintsAPI/GetComplaintsMainGroupList", {
            headers: getheader(),
            method: "GET",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                return dispatch({
                    type: "GET_COMPLAINT_MAINGROUP",
                    data: res
                });
            })
    }
}
export function getComplaintsSubGroup(mainGroupID) {
    return dispatch => {
        dispatch({
            type: "GET_COMPLAINT_SUBGROUP",
            data: "PENDING"
        });
        fetch(serverUrl + "api/ComplaintsAPI/GetComplaintsSubGroup?mainGroupID=" + mainGroupID, {
            headers: getheader(),
            method: "GET",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                return dispatch({
                    type: "GET_COMPLAINT_SUBGROUP",
                    data: res
                });
            })
    }
}
export function getComplaintsTargetList() {
    return dispatch => {
        dispatch({
            type: "GET_COMPLAINT_TARGETS",
            data: "PENDING"
        });
        fetch(serverUrl + "api/ComplaintsAPI/GetComplaintsTargetList", {
            headers: getheader(),
            method: "GET",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                return dispatch({
                    type: "GET_COMPLAINT_TARGETS",
                    data: res
                });
            })
    }
}
export function addNewComplaint(data, attachFile) {
    return dispatch => {
        dispatch({
            type: "َADD_NEW_COMPLAINT",
            data: "PENDING"
        });
        fetch(serverUrl + "api/ComplaintsAPI/AddNewComplaintByCustomer", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                    alert("اشکال در عملیات ثبت");
                }
                else {
                    alert("ثبت با موفقیت انجام شد. شماره پیگیری: " + res.TrackingNumber);
                    if (attachFile) {
                        attachFile(res.ID);
                    }
                }

                return dispatch({
                    type: "َADD_NEW_COMPLAINT",
                    data: res
                });
            })
    }
}
export function getComplaintList(serial) {
    return dispatch => {
        dispatch({
            type: "GET_COMPLAINT_LIST",
            data: "PENDING"
        });
        fetch(serverUrl + "api/ComplaintsAPI/GetCustomerComplaintList?productSerial="+serial, {
            headers: getheader(),
            method: "GET",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                return dispatch({
                    type: "GET_COMPLAINT_LIST",
                    data: res
                });
            })
    }
}